import { GetSectionsApi } from "network/user";
import { GetUserAPI } from "network/user";
import React, { createContext, useEffect, useState } from "react";

export const UserContextProvider = createContext();
export default function UserContext({ children }) {
  const token = localStorage.getItem("token");
  const [user, setUser] = useState([]);
  const [sections, setSections] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [notifications, setNotifications] = useState({
    items: [],
    count: 0,
  });
  const fetchUser = async () => {
    try {
      const response = await GetUserAPI();
      if (response.success) {
        setUser(response.data);
      }
    } catch (error) {}
  };
  const fetchSection = async () => {
    setIsLoading(true);
    try {
      const response = await GetSectionsApi();
      if (response.success) {
        setSections(response.data);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (token) {
      fetchSection();
      fetchUser();
    }
  }, [token]);
  return (
    <UserContextProvider.Provider
      value={{
        sections,
        user,
        setUser,
        isLoading,
        fetchUser,
        fetchSection,
        notifications,
        setNotifications,
      }}
    >
      {children}
    </UserContextProvider.Provider>
  );
}
